var map = {
	"./au-jewlr4-how-it-works.png": 75116,
	"./ca-jewlr4-how-it-works.png": 6126,
	"./uk-jewlr4-how-it-works.png": 69466,
	"./us-jewlr4-how-it-works.png": 63954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80123;